import * as React from 'react';
import { Link } from '../Link';
import * as styles from './styles.css';
export function Help(_ref) {
  var query = _ref.query,
      text = _ref.text,
      onClick = _ref.onClick;
  var link = React.useMemo(function () {
    return query ? "/contacts?".concat(query) : '/contacts';
  }, [query]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, /*#__PURE__*/React.createElement(Link, {
    href: link,
    target: "_blank",
    onClick: onClick
  }, text || 'Нужна помощь?'));
}